window.addEventListener('load', function () {
    let cityTriggers = document.querySelectorAll('.js-choose-city')
    cityTriggers.forEach(function (item) {
        item.addEventListener('click', function (e) {
            if (item.classList.contains('isActive')) return

            let code = item.dataset.code;
            if (code) {
                setCity(code)
            }
        })
    })
})

function setCity(code) {
    $.ajax({
        url: '/local/scripts/set-city.php',
        type: 'post',
        data: {'code': code},
        success(response) {
            let parsedResponse = JSON.parse(response)
            if (parsedResponse.status) {
                location.reload()
            } else {
            }
        },
        error(response) {
        }
    })
}

export { setCity }